import { AbstractControl } from '@angular/forms';

export function PersonNameValidator(control: AbstractControl) {

    const Regex = /^[a-zA-Z 0-9\.\-]+$/;

    if (Regex.test(control.value) || control.value ==='') {
        return null;
    }

    return {
        personNameValid: true
    };
}